import { Flex } from '@mantine/core';

export const FlexResolver = Flex.extend({
  styles: {
    root: {
      boxSizing: 'border-box',
    },
  },
});
